import React from 'react'

import { columnHelper } from './tableSetup'
import { COLUMN_IDS } from './columnIds'
import { RowActionsMenu, IRowActionsMenuProps } from '../components/RowActionsMenu'

export const SHARED_COLUMN_WIDTHS: Record<string, number> = {
  [COLUMN_IDS.name]: 280,
  [COLUMN_IDS.team]: 180,
  // The menu floats over the row's right edge rather than filling a column, so the strip only has
  // to be wide enough to keep the last value clear of it: a 20px icon with 12px either side.
  [COLUMN_IDS.actions]: 44,
}

export function actionsColumn(rowMenu: Omit<IRowActionsMenuProps, 'user'>) {
  return columnHelper.display({
    id: COLUMN_IDS.actions,
    enableHiding: false,
    header: () => null,
    cell: ({ row }) => <RowActionsMenu user={row.original} {...rowMenu} />,
  })
}
